import { cn } from '@jeraisonne/ui';

/** Petit indicateur de chargement (hérite de la couleur du texte). */
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-block h-3.5 w-3.5 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent',
        className,
      )}
    />
  );
}

/** Chargement pleine zone : spinner bien visible + libellé (écrans de lancement). */
export function PageLoader({ label = 'Chargement…' }: { label?: string }) {
  return (
    <div role="status" className="flex min-h-[60vh] flex-col items-center justify-center gap-3">
      <Spinner className="text-accent-400 h-8 w-8 border-[3px]" />
      <p className="text-ink-400 text-sm">{label}</p>
    </div>
  );
}
